import { render, staticRenderFns } from "./CheckboxVcDemo.vue?vue&type=template&id=3070a6d8&scoped=true&"
import script from "./CheckboxVcDemo.vue?vue&type=script&lang=js&"
export * from "./CheckboxVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxVcDemo.vue?vue&type=style&index=0&id=3070a6d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070a6d8",
  null
  
)

export default component.exports